export default [
  {
    path: '/access-key',
    component: DefaultLayout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "AccessKeyTable" */ './pages/AccessKeyTable.vue'),
        meta: {
          title: 'AccessKey列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "AccessKeyTable" */ './pages/AccessKeyForm.vue'),
        meta: {
          title: '创建AccessKey',
        },
      },
    ],
  },
]
